import { createI18n } from "vue-i18n";

import enLocale from "element-plus/es/locale/lang/en";
import zhLocale from "element-plus/es/locale/lang/zh-cn";

import { getLocalStorage } from "@/methods/storage";
import langs from "./langs.js";

const messages = {
  en: {
    ...langs.en,
    ...enLocale,
  },
  zh: {
    ...langs.zh,
    ...zhLocale, // 或者用 Object.assign({ message: '你好' }, zhLocale)
  },
  ja: {
    ...langs.ja,
    ...zhLocale,
  },
  silentTranslationWarn: true,
};

// Create VueI18n instance with options
const i18n = createI18n({
  locale: getLocalStorage("misun_langs") || "zh", // set locale (or || window.navigator.language)
  messages, // set locale messages
});

i18n.locale === "en"
  ? document.getElementById("app").classList.add("main_en")
  : document.getElementById("app").classList.remove("main_en");

export default i18n;
